var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_index"},[(!_vm.$store.state.isMobile)?_c('MainHeader'):_c('MainMobileHeader'),_c('router-view',{staticStyle:{"flex":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }